function productFactory($http) {
  function getAll() {
    return $http
      .get('/admin/product', { params: { type: 'premium' } })
      .then(response => response.data);
  }
  return { getAll };
}
productFactory.$inject = ['$http'];
export default productFactory;



// WEBPACK FOOTER //
// ./client/app/components/product/product.factory.js